module.exports = __webpack_public_path__ + "static/media/teacher25.583361a0.png";